import { render, staticRenderFns } from "./GreetingRouteView.vue?vue&type=template&id=8158ef5c"
import script from "./GreetingRouteView.vue?vue&type=script&lang=js"
export * from "./GreetingRouteView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports